export default __webpack_public_path__ + "static/media/top_akikun.0fdb6e98.png";